import { Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import { ControlledFormDateTimePicker } from 'src/shared/components/form/controlledDateTimePicker';
import ControlledTextField from 'src/shared/components/form/controlledTextField';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';

export const EventFormStepDateAndPlace = () => {
  return (
    <GridWrapper>
      <Grid item xs={12}>
        <Typography variant='body1' sx={{ fontWeight: 600, mb: -1 }}>
          {t('event:date')}
        </Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <ControlledFormDateTimePicker name='date' required label={t('event:formFields.date')} />
      </Grid>
      <Grid item xs={12} lg={6}>
        <ControlledFormDateTimePicker name='lastDateForApplication' required label={t('event:formFields.applicationDate')} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant='body1' sx={{ fontWeight: 600, mb: -1 }}>
          {t('event:place')}
        </Typography>
      </Grid>

      <Grid item xs={12} lg={3.5}>
        <ControlledTextField
          name='locationName'
          required
          label={t('common:name')}
          inputProps={{ maxLength: 250 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid item xs={12} lg={3.5}>
        <ControlledTextField
          name='address'
          required
          label={t('event:formFields.address')}
          inputProps={{ maxLength: 100 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid item xs={12} lg={2.5}>
        <ControlledTextField
          name='postcode'
          required
          label={t('event:formFields.postCode')}
          inputProps={{ maxLength: 50 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>

      <Grid item xs={12} lg={2.5}>
        <ControlledTextField
          name='city'
          required
          label={t('event:formFields.city')}
          inputProps={{ maxLength: 100 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Grid>
    </GridWrapper>
  );
};
